import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { PersonDto } from '../../../core/dto/person';
import { Router } from '@angular/router';

@Component({
    selector: 'isav-people-shared-view-page',
    templateUrl: './people-shared-view-page.html',
    styleUrls: ['./people-shared-view.sass'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PeopleSharedViewPage {
    @Input() person: PersonDto;
    @Input() isGlobalMap: boolean = false;

    constructor(public router: Router) {}
}
